import React from 'react';
import { resolveMetricValue, formatMetricValue } from './analysisMetrics';

const AnalysisKpiGrid = ({
  metrics = [],
  row,
  bundle,
  ctx,
  formatCurrency,
  title,
}) => {
  if (!metrics.length) return null;

  return (
    <div className="space-y-2" data-testid="analysis-kpi-grid">
      {title && (
        <h3 className="text-sm font-semibold text-foreground" style={{ fontFamily: 'var(--font-heading)' }}>
          {title}
        </h3>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
        {metrics.map((metric) => {
          const value = resolveMetricValue(metric, row, bundle, ctx);
          const isPositive = metric.higherIsBetter === false
            ? value <= 0
            : metric.higherIsBetter === true
              ? value >= 0
              : true;
          const color = metric.format === 'percent'
            ? 'var(--color-primary)'
            : isPositive
              ? 'var(--color-success)'
              : 'var(--color-destructive)';

          return (
            <div
              key={metric.id}
              className="rounded-xl border border-border bg-card px-3 py-3 hover:border-primary/30 transition-colors"
            >
              <p className="text-[11px] text-muted-foreground mb-0.5 line-clamp-2">{metric.label}</p>
              <p
                className="text-base font-semibold text-foreground tabular-nums"
                style={{ fontFamily: 'var(--font-data)', color: metric.format === 'currency' && value < 0 ? 'var(--color-destructive)' : undefined }}
              >
                {formatMetricValue(value, metric.format, formatCurrency)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnalysisKpiGrid;


